<template>
  <!-- Page Content -->
  <div class="content container-fluid">
    <!-- Page Header -->

    <!-- /Page Header -->

    <!-- Search Filter -->
    <div class="row filter-row">
      <div class="col-sm-6 col-md-3">
        <div class="form-group form-focus">
          <input
            class="form-control floating"
            v-model="serverParams.columnFilters.period"
            type="month"
          />
          <label class="focus-label">Period</label>
        </div>
      </div>

      <div class="col-sm-6 col-md-3">
        <a
          href="javascript:void(0)"
          @click.prevent="searchData"
          class="btn btn-success btn-block"
        >Search</a>
      </div>
    </div>
    <!-- /Search Filter -->
    <div class="row">
      <div class="col-md-12">
        <div class="table-responsive">
          <table class="table table-striped custom-table mb-0">
            <thead>
              <tr>
                <th class="text-center">#</th>
                <th class="text-center" style="width:100px;">Request Date</th>
                <th class="text-center">Nama Member</th>
                <th class="text-center">Email Member</th>
                <th class="text-center">No. WA Member</th>
                <th class="text-center">Bank</th>
                <th class="text-center">Account Information</th>
                <th class="text-center">Account No</th>
                <th class="text-right">Gross (IDR)</th>
                <th class="text-right">Bank Fee (IDR)</th>
                <th class="text-right">Amount Nett (IDR)</th>
                <th class="text-center" style="width:100px;">Status</th>
                <th class="text-center">Paid Date</th>
              </tr>
            </thead>
            <tbody>
              <template v-if="loading">
                <tr>
                  <td colspan="13">
                    <Skeleton :count="1" />
                  </td>
                </tr>
              </template>
              <template v-if="rows.length">
                <tr v-for="(row,index) in rows" :key="index">
                  <td class="text-right">{{row.number}}</td>
                  <td>{{formatLocalDate(row.create_datetime)}}</td>
                  <td class="text-right">{{row.member_name}}</td>
                  <td class="text-right">{{row.member_email}}</td>
                  <td class="text-right">{{row.member_mobilephone}}</td>
                  <td class="text-right">{{row.member_bank_name}}</td>
                  <td class="text-right">{{row.member_bank_account_name}}</td>
                  <td class="text-right">{{row.member_bank_account_no}}</td>
                  <td class="text-right">{{formatPriceRupiah(row.gross)}}</td>
                  <td class="text-right">{{formatPriceRupiah(row.bank_transfer_fee)}}</td>
                  <td class="text-right">{{formatPriceRupiah(row.nett)}}</td>
                  <td class="text-left">
                    <div v-if="row.status=='0'" class="text text-warning">Waiting</div>
                    <div v-else-if="row.status=='1'" class="text text-info">Processing</div>
                    <div v-else-if="row.status=='2'" class="text text-danger">Reject</div>
                    <div v-else-if="row.status=='3'" class="text text-info">Refund</div>
                    <div v-else-if="row.status=='4'" class="text text-success">Paid</div>
                  </td>

                  <td class="text-center">
                    <span v-if="row.paid_datetime>0">{{formatLocalDate(row.paid_datetime)}}</span>
                    <span class="text-center" v-else>-</span>
                  </td>
                </tr>
              </template>
              <template v-if="loading">
                <tr>
                  <td colspan="13">
                    <Skeleton :count="1" />
                  </td>
                </tr>
              </template>
              <template v-else-if="rows.length<1 && !loading">
                <tr>
                  <td colspan="13" class="text-center">-empty-</td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <span class="footer__row-count__label">Displaying</span>
        <select
          @change="onPerPageChange(serverParams.perPage)"
          autocomplete="off"
          name="perPageSelect"
          v-model="serverParams.perPage"
          style="width: 100px;"
          class="select-to-paginasi"
        >
          <option value="10">10 / page</option>
          <option value="20">20 / page</option>
          <option value="30">30 / page</option>
          <option value="40">40 / page</option>
          <option value="50">50 / page</option>
        </select>
        <span class="footer__row-count__label">of {{ totalRecords }} total records</span>
      </div>
      <div class="col-sm-12 col-md-6 text-right">
        <a
          href="javascript:void(0)"
          @click="onPrevChange(parseInt(currentPage))"
          tabindex="0"
          class="btn"
          :class="{ disabled: parseInt(currentPage) - 1 <= 0 }"
        >
          <span class="chevron left"></span>
          <span>Prev</span>
        </a>
        page
        <input
          style="width:100px;"
          min="1"
          type="number"
          v-model="currentPage"
          @keyup.enter="onPageChange(parseInt(currentPage))"
          class
        />
        of {{ Math.ceil(totalRecords / serverParams.perPage) }}
        <a
          href="javascript:void(0)"
          @click="onNextChange(parseInt(currentPage))"
          tabindex="0"
          class="footer__navigation__page-btn"
          :class="'btn '+{
                    disabled:
                      parseInt(currentPage) + 1 >
                      Math.ceil(totalRecords / serverParams.perPage)
                  }"
        >
          <span>Next</span>
          <span class="chevron right"></span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import {
  convertUTCDatetimeToUnix,
  formatLocalDate,
  nFormatter,
  getCurrentMonth,
  formatDate,
  labelStatusMessage,
  getWhatsappNumberFromJid,
  formatPriceRupiah
} from "@/utils/helper";
import { Skeleton } from "vue-loading-skeleton";

export default {
  components: {
    Skeleton
  },
  data() {
    return {
      loading: false,
      rows: [],
      totalRecords: 0,
      currentPage: 1,
      rowPage: 1,
      serverParams: {
        columnFilters: {
          period: this.getCurrentMonth(),
          status: "paid"
        },
        page: 1,
        perPage: 20 // perPage
      }
    };
    //  isactive : true
  },
  created() {
    this.loadItems();
    this.currentPage = this.serverParams.page;
  },
  methods: {
    convertUTCDatetimeToUnix(value) {
      return convertUTCDatetimeToUnix(value);
    },
    formatPriceRupiah(value) {
      return formatPriceRupiah(value);
    },

    formatLocalDate(value) {
      return formatLocalDate(value);
    },
    updateParams(newProps) {
      // console.log("newprops", newProps);
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    async onPageChange(page) {
      await this.updateParams({ page: page });
      this.currentPage = page;
      await this.loadItems();
    },
    async onNextChange(page) {
      if (
        page + 1 <=
        Math.ceil(this.totalRecords / this.serverParams.perPage)
      ) {
        await this.updateParams({ page: page + 1 });
        this.currentPage = page + 1;
        await this.loadItems();
      }
    },
    async onPrevChange(page) {
      // console.log("this.currentPage:: ", this.currentPage);
      if (this.currentPage == 1) {
        return;
      }
      if (
        page - 1 <=
        Math.ceil(this.totalRecords / this.serverParams.perPage)
      ) {
        await this.updateParams({ page: page - 1 });
        this.currentPage = page - 1;
        await this.loadItems();
      }
    },
    async onPerPageChange(params) {
      await this.updateParams({
        page: this.currentPage,
        perPage: this.serverParams.perPage
      });
      await this.loadItems();
    },
    formatDate(value) {
      return formatDate(value);
    },
    getCurrentMonth() {
      return getCurrentMonth();
    },
    nFormatter(value) {
      return nFormatter(value);
    },
    async searchData() {
      // this.currentPage = await 1;
      // this.serverParams.columnFilters.page = await 1;
      // await this.getListData();

      this.currentPage = 1;
      this.rows = await [];
      this.loading = await true;
      this.totalRecords = await 0;
      var params = await { page: this.currentPage };
      await this.updateParams(params);
      await this.loadItems();
      this.loading = await false;
    },
    async loadItems() {
      // console.log("serverparam", this.serverParams);
      this.loading = await true;
      this.serverParams.page =
        this.serverParams.page - 1 <= 0
          ? await 0
          : await ((this.serverParams.page - 1) * this.serverParams.perPage);

      await this.$store
        .dispatch("referral/withdrawList", this.serverParams) // sesuai kan dengan method di API
        .then(response => {
          const { data } = response;
          this.totalRecords = data.totalRecords;
          this.rowPage = data.page;
          this.rows = data.data;
          // console.log("rows", this.rows);
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  mounted() {
    // Date Time Picker

    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%"
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }

    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "withdraw_list"
};
</script>


// WEBPACK FOOTER //
// src/views/referral/components/withdrawList.vue